<template>
  <div class="bd_y" v-if="show_body">
    <div class="top_list">
      <ul class="clearfix">
        <li @click="switch_tab(0)" :class="{on: main_show==0}">
          查看邀请
          <img src="@a/xsj.png" alt />
        </li>
        <li @click="switch_tab(1)" :class="{on: main_show==1}">
          累计推广订单
          <img src="@a/xsj.png" alt />
        </li>
      </ul>
    </div>
    <!-- 查看邀请 -->
    <div class="main_list" v-if="main_show==0">
      <ul v-if="list && list.length>0">
        <li class="clearfix cjv" v-for="(item,index) in list" :key="index">
          <img :src="item.headimgurl" class="xtx" />
          <span class="rank_name text-ellipsis">{{item.nickname}}</span>
          <span class="rank_right">
            <span>{{formatHandle(item.view_time)}}</span>
            <span class="state" v-if="item.state ==1">查看并报名</span>
            <span class="state" v-if="item.state ==2">查看</span>
          </span>
        </li>
      </ul>
      <div class="empry" v-else>
        <img src="@a/empry.png" alt />
        <p>还没有好友报名哦(￣▽￣)</p>
        <a @click="card_show=true">送好友{{promoter.first_fee}}元红包</a>
      </div>
    </div>
    <!-- 累计推广订单 -->
    <div class="main_list" v-if="main_show==1">
      <ul v-if="list.length>0">
        <li class="clearfix cjv" v-for="(item,index) in list" :key="index">
          <img :src="item.headimgurl" class="xtx" />
          <span class="rank_name text-ellipsis">{{item.nickname}}</span>
          <div class="rank_right">
            <!-- 已结算 -->
            <div class="settlement">
              <span class="time" v-if="item.fee>=0" >已结算：{{item.fee}} 元</span>
              <span>{{formatHandle(item.pay_time)}}</span>
            </div>
            <div class="pay">
              <span class="state" v-if="item.state==1" >支付成功</span>
            </div>
          </div>
        </li>
      </ul>
      <div class="empry" v-else>
        <img src="@a/empry.png" alt />
        <p>还没有好友报名哦(￣▽￣)</p>
        <a @click="card_show=true">送好友{{promoter.first_fee}}元红包</a>
      </div>
    </div>
    <div class="pop_img" v-show="card_show" @click="card_show=false"></div>
  </div>
</template>
<script>
import { progressList } from "@/api/training";
import { shareCon } from "@/utils/wxconfig";
import { deepCopy } from "@/utils/tools";
export default {
  data() {
    return {
      show_body: false,
      list: [],
      size: 15,
      main_show: 0,
      card_show: false,
      type_obj: {},
      pager: {},
      tab_index:null,
      promoter: {}
    };
  },
  methods: {
    /*
     *@param: data
     *@return: date
     *@Description: 去掉后边的秒
     *@MethodAuthor:  Zhang Xiao Guang
     *@Date: 2019-09-27 11:57:33
    */
    formatHandle(date){
      return date.substring(0,date.length-3);
    },
    pullData(main_show) {
      this.$toast.loading({
        mask: true,
        message: "加载中..."
      });
      let obj = {
        page:
          (this.main_show == this.tab_index &&this.pager && Object.keys(this.pager).length > 0)
            ? (this.pager.page += 1)
            : 1,
        size: this.size,
        course_id: this.$route.query.course_id,
        pay: main_show?main_show:this.main_show
      };
      /*
       *@param: page页数，size数量，course_id课程id，pay是否支付，0=查看列表，1=邀请列
       *@return: list：列表，uid：用户ID，nickname：昵称，
          headimgurl：头像，view_time：查看时间，
          pay_time：支付时间，state：状态，1=已购买，2=未购买，fee：返现金额pager：分页对象
       *@Description:
       *@MethodAuthor:  Zhang Xiao Guang
       *@Date: 2019-09-27 11:28:45
      */
      progressList(obj).then(data => {
        //请求完数据后再切换选项栏
        this.main_show= main_show?main_show:this.main_show;

        this.pager = deepCopy(data.pager);
        this.show_body = true;
        if(this.main_show != this.tab_index){
            this.list.splice(0,this.list.length);
            this.tab_index = this.main_show;
        }
        this.list=[...this.list,...data.list];
        this.promoter = data.promoter;
        this.$toast.clear();
        this.type_obj = {
          nickname: data.user.nickname,
          train_name: data.course.name,
          train_id: data.course.id,
          share: data.user.id
        };
        shareCon("training", this, this.type_obj);
      });
    },
    backTop() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    switch_tab(main_show) {
      this.pullData(String(main_show));
      this.backTop();
    }
  },
  created() {
    this.main_show = this.$route.query.tab
        ? this.$route.query.tab
        : this.main_show;
    this.pullData();
  },
  mounted(){
    //滚动监听
    window.onscroll = ()=>{
        let that = this;
        let marginBot = 0;
        if (document.documentElement.scrollTop){
            let X=document.documentElement.scrollHeight;
            let Y=document.documentElement.scrollTop+document.body.scrollTop;
            let Z=document.documentElement.clientHeight;
            marginBot=X-Y-Z;
        } else {
            let J=document.body.scrollHeight;
            let I=document.body.scrollTop;
            let K=document.body.clientHeight;
            marginBot=J-I-K;
        }

        if(marginBot<=0 && (this.pager &&(this.list.length< this.pager.count))) {
            that.pullData();
        }
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@s/remChange.scss";
.bd_y {
  margin: 30px;
  border-radius: 8px;
}

.pop_img {
  width: 100%;
  height: 100%;
  z-index: 100001;
  position: fixed;
  top: 0;
  left: 0;
  background: url(../../../assets/popse.png) no-repeat top center;
  background-size: cover;
}

.top_list {
  width: 690px;
  height: 80px;
  background: rgba(235, 80, 50, 1);
  border-radius: 8px 8px 0px 0px;
  margin: 0 auto;
  ul li {
    float: left;
    font-size: 32px;
    color: #e1e1e1;
    width: 50%;
    text-align: center;
    line-height: 80px;
    position: relative;
    img {
      width: 26px;
      position: absolute;
      bottom: 0;
      left: 50%;
      margin-left: -13px;
      display: none;
    }
  }
  .on {
    color: #fff;
    img {
      display: block;
    }
  }
}

.main_list {
  ul li {
    display: flex;
    align-items: center;
    padding: 16px 30px;
    border-bottom: 2px solid #e1e1e1;
    background-color: #fff;
    img {
      height: 64px;
      width: 64px;
      margin-right: 10px;
      border-radius: 50%;
    }
    span {
      font-size: 26px;
      color: #333;
    }
    span.rank_name {
      width: 122px;
    }
    .rank_right {
      display: flex;
      margin-left: 65px;
      .settlement{
        display: flex;
        flex-direction: column;
        .time{
          color: #F57F17;
        }
      }
      .pay{
        display: flex;
      }
      .state{
        margin-top: auto;
        margin-left: 18px;
      }
    }
  }
}

.empry {
  margin-top: 287px;
  text-align: center;
  img {
    width: 180px;
  }
  p {
    margin-top: 30px;
    font-size: 26px;
    color: #999;
  }
  a {
    width: 370px;
    height: 66px;
    background: rgba(235, 80, 50, 1);
    border-radius: 33px;
    display: inline-block;
    font-size: 34px;
    color: #fff;
    line-height: 66px;
    margin-top: 50px;
  }
}
</style>
